import gqlRequest from 'sb-request/graphql'
import { getGqlQuery } from 'common/helpers'
import { useEffect, useReducerState } from 'sb-hooks'


const usePlansQuery = ({ products, billing, shipping, couponCode, couponType } = {}) => {
  const [ { isFetching, plans }, setState ] = useReducerState({
    isFetching: false,
    plans: [],
  })

  useEffect(() => {
    setState({ isFetching: true })

    let plansQueryInput = {
      products,
      shipping,
      billing,
    }

    if (couponCode) {
      plansQueryInput = {
        ...plansQueryInput,
        couponCode,
        couponType: {
          value: couponType,
          isEnum: true,
        },
      }
    }

    gqlRequest.post('graphql?name=plansQuery', {
      body: {
        query: `{
          plans: ${getGqlQuery('plansQuery', { input: plansQueryInput })} {
            name
            save
            price
            selected
            productCount
            productPrice
            productsPerPeriod
          }
        }`,
      },
    })
      .then(({ plans }) => setState({ plans }))
      .finally(() => setState({ isFetching: false }))
  }, [])

  return {
    isFetching,
    plans,
  }
}


export default usePlansQuery
